import request from '@/utils/request'

export function devUpdateApi(query) {
  return request({
    url: '?c=fam&a=behavior&do=devupdate',
    method: 'get',
    params: query
  })
}
